import React, { useEffect, useContext, useState } from "react";
import { DataContext } from '../../data/DataContext';
import Input from "../controls/Input";
import Modal from "react-modal";
import SwitchButton from "../controls/SwitchButton";
import CardInput from "../controls/CardInput";
import TableCober from "../controls/TableCober";
import { IconVisaMastercard } from '../../svg/index';
import { getResumen } from '../../services/Tarficar';
import http from '../../../../services/http';
import { endPoints } from '../../../../utils/constanst';


const Step4 = () => {
    const { SOA, setSOA, changeHandler } = useContext(DataContext);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const optionsUsd = { style: 'currency', currency: 'USD' };
    const numberFormatUsd = new Intl.NumberFormat('en-US', optionsUsd);
    let isAmex = false;

    const cardHandler = cardData => {
   
         isAmex = String(cardData.numeroTarjeta).substring(0, 2) === '34' || String(cardData.numeroTarjeta).substring(0, 2) === '37';
         setSOA({...SOA,isAmex:isAmex, numeroTarjeta:cardData.numeroTarjeta });
    }
    const onClickCobertura = () => {
        handleShow();

    }

    const getResumeRate = () => {
        const prima = getResumen(SOA.catalogos.rates);
        setSOA({ ...SOA, montoPagar: prima, montoPagarVisualizar: numberFormatUsd.format(Number.parseFloat(prima).toFixed(2)) })
        console.log(prima);
    }

    useEffect(() => {
        getResumeRate();
       
    }, []);
    const buildDetTable = () => {
        let cob = [];
        SOA.catalogos.coberturas.coverages.map(item => {
            if (item.obligatoria) {
                let cobertura = SOA.catalogos.rates.find(x => x.idCob == item.idCob && x.bIncluirCob == false);
                if (cobertura != undefined)
                    cob.push({ "nombre": item.nombre, "valor": numberFormatUsd.format(Number.parseFloat(cobertura.sa).toFixed(2)) });
            }

        })
        return cob;
    };

    const paySoa = () => { setSOA({ ...SOA, usarTarjeta: true }) }

    /*
      <div className="control-button-pay mt-20">
                        <button className="control-button-btn-pay pay" type="button" onClick={paySoa}>¡Pagar ya!</button>
                    </div>
    */

    return (
        <div className="step">
            <div className="step-container-soa">
                <div className="mt-15">
                    <span className="title2">
                        Resumen de Compra
                </span>
                </div>
                <div className="mt-15 mb-30">
                    <span className="title3">
                        A continuación, se presenta el monto de tu compra de Seguro Obligatorio y la entrega
                </span>
                </div>
                <div className="lbl-input">
                    <span>Conocé las coberturas de tu póliza</span>
                </div>
                <button tabIndex="-1" className="control-button-btn-cob" type="button" onClick={onClickCobertura}>Ver coberturas</button>
                <Input labelLeft="Dólares ($)" readOnly={true} label="Monto a pagar" value={SOA.montoPagarVisualizar} field="montoPagarVisualizar" onChange={changeHandler} ></Input>
                <SwitchButton label="Opción de entrega" labelInfo="*Delivery solo en ciudad de Managua" value={SOA.esDelivery} si="Delivery" no="En sucursal" onClick={(value) => setSOA({ ...SOA, esDelivery: value })} />
                {SOA.esDelivery && <SwitchButton label="¿Dónde te entregraremos la póliza?" value={SOA.esDomicilio} si="Domicilio" no="Otra dirección" onClick={(value) => setSOA({ ...SOA, esDomicilio: value })} />}
                {SOA.esDomicilio == false && SOA.esDelivery && <Input label="Agregar dirección de entrega de póliza" type="textarea" value={SOA.direccionEntrega} field="direccionEntrega" onChange={changeHandler} classNameInput="input-field-area" ></Input>}
                {/* <SwitchButton label="Opción de pago" value={SOA.esTelepago} si="Telepago" no="En línea" field="esTelepago" onClick={(value) => setSOA({ ...SOA, esTelepago: value })} /> */}
                {SOA.esTelepago == false && <div className="container-pay mt-20">
                    <div className="mt-15 mb-20">
                        <span className="title2 mb-15">
                            Realizá tu pago aquí  </span>
                    </div>
                    <Input label="Nombre tarjeta" placeholder="Ejemplo: Juan Pérez" value={SOA.nombreTarjeta} field="nombreTarjeta" onChange={changeHandler} ></Input>
                    <CardInput
                        placeholder='0000-0000-0000-0000'
                        label='Numero de tarjeta'
                        field='numeroTarjeta'
                        title='Tarjeta inválido'
                        value={SOA.numeroTarjeta}
                        type='maskInput'
                        onChange={cardHandler}
                        icon={<IconVisaMastercard />}
                    ></CardInput>
                    <div className="col">
                        <Input label="Expiración" placeholder="MM/YY"
                            classNameInput="input-field-col" value={SOA.expiracionTarjeta} field="expiracionTarjeta"
                            onChange={changeHandler}
                            type='mask'
                            mask='99/99'
                            title='Fecha invalida'
                        ></Input>

                        {SOA.isAmex && <Input type="mask" label="CVV" value={SOA.cvvTarjeta} field="cvvTarjeta" onChange={changeHandler} placeholder="0000" mask='9999' title='Código inválido' pattern="\d\d\d\d"  ></Input>}
                        {!SOA.isAmex && <Input type="mask" label="CVV" value={SOA.cvvTarjeta} field="cvvTarjeta" onChange={changeHandler} placeholder="000" mask='999' title='Código inválido' pattern="\d\d\d"  ></Input>}

                    </div>

                </div>}

            </div>
            <Modal className="modal" isOpen={show} show={show} ariaHideApp={false}>
                <div className="modal-title">
                    <span className="txt-title-modal">Coberturas de tu póliza</span>
                </div>
                <div className="modal-body-table">
                    <TableCober array={buildDetTable()} />
                </div>
                <div className="modal-footer">
                    <button type="button" className="modal-btn-close" onClick={handleClose}>Cerrar</button>
                </div>
            </Modal>
        </div>
    );
};

export default Step4;